// extracted by mini-css-extract-plugin
export default {"scene":"style_scene__xLDJG"};